import { generatePath } from 'react-router';
import { sourceKeyMapping, paths } from '@AppRoutes/constants';
import { generateHeatmapPath, generateResultsPath } from '@AppRoutes/utils';
import history from '@AppRoutes/history';
import * as AuthUtils from '@Services/Auth/AuthUtils';
import UserInterfaceConfig from '@Services/UserInterfaceConfig';
import Breadcrumb from '@Services/Breadcrumb';
import History from '@Services/History';
import loginConstants from '@Services/Login/LoginConstants';
import ResultsInfo from '@Services/ResultsInfo';
import each from 'lodash/each';
import findLastIndex from 'lodash/findLastIndex';
import extend from 'lodash/extend';

let visitedStates = [];

export const init = () => {
  const currentUser = (AuthUtils && AuthUtils.getUser()) || {};
  if (!currentUser.history) {
    Object.assign(currentUser, {
      history: {
        breadcrumbs: {},
        viewedResultsParams: {},
        recentSearches: [],
        savedSearches: [],
      },
    });
  }
  UserInterfaceConfig.applySchema('default', 1);
  AuthUtils.updateUser(currentUser);
};

export const addState = (state, params) => {
  const stateObj = {
    name: state,
    params,
  };
  visitedStates.push(stateObj);
};

// Updated for React routes
export const getStatePathName = (state) => {
  if (!state) return null;

  const _statePath = Object.keys(sourceKeyMapping).find((_path) => sourceKeyMapping[_path] === state.name);
  if (_statePath === paths.RESULTS) {
    return generateResultsPath(state.params);
  }
  if (_statePath === paths.HEATMAP) {
    return generateHeatmapPath({ ...state.params, isHeatmap: true });
  }
  return generatePath(_statePath, state.params);
};

export const getLastVisitedState = (...args) => {
  if (!visitedStates.length) {
    return null;
  }

  let lastStateIndex = null;
  let lastState = null;

  each(args, (proposedState) => {
    const proposedStateIndex = findLastIndex(visitedStates, (state) => state && state.name === proposedState);

    if (proposedStateIndex >= 0 && (lastStateIndex === null || proposedStateIndex > lastStateIndex)) {
      lastStateIndex = proposedStateIndex;
      lastState = visitedStates[lastStateIndex];
    }
  });
  return (
    lastState && {
      ...lastState,
      pathName: getStatePathName(lastState),
    }
  );
};

export const getLastVisitedStateForLogin = () => getLastVisitedState(...loginConstants.STATE_WHITELIST);

export const viewHistory = (item) => {
  if (item.resultSize) {
    History.restoreHistory(item)
      // eslint-disable-next-line no-shadow
      .then((item) => {
        Breadcrumb.resetBreadcrumbs();
        ResultsInfo.clearResultsInfo();
        // eslint-disable-next-line no-param-reassign
        item.isHistoryBreadcrumb = true;
        const params = {
          databaseId: item.databaseId,
          context: item.context,
          resultName: item.resultName,
          searchId: item.searchId,
          pageNumber: 1,
          sort: '',
          hitSetKey: item.hitSetKey,
        };
        Breadcrumb.activateBreadcrumb(item.resultName, item.databaseId);
        Breadcrumb.createBreadcrumb(item, item.resultSize, item.filters)
          .then(() => {
            if (item.isHeatmapShown) {
              extend(params, {
                sortedMatrixName: item.sortedMatrixName,
                index: item.index || null,
                isRow: item.isRow || null,
                ascending: item.ascending || null,
                fromContext: item.fromContext,
                context: 'dpitems',
                hitSetKey: item.hitSetKey,
                resultName: item.heatmapResultName,
                searchId: item.searchId,
                order: item.order,
                sort: item.sort,
              });
            }
            Breadcrumb.updateActiveParams(null); // reset active resultName
            const pathName = item.isHeatmapShown ? generateHeatmapPath(params) : generateResultsPath(params);
            history.push({
              pathname: pathName,
              state: { ...params, order: item.order, sort: item.sort },
            });
          })
          .catch(Logger.error);
      })
      .catch(Logger.error);
  }
};

// TODO Need to be revised, changing it breaks after auth redirects
export const softClear = () => {
  visitedStates.length = 1;
};

export const hardClear = () => {
  visitedStates = [];
};

export const importVisitedStates = (states) => {
  visitedStates = states;
};
